// import { testDate } from '../deleteOutHoursDRP'

// console.log(testDate)

export const getDayOfWeek = () => {
  const moment = new Date()
  const dayOfWeek = moment.getDay()
  const hour = moment.getHours()

  let counter = 0

  if (dayOfWeek === 5 && hour >= 20) {
    counter = 3
    return counter
  }

  if (dayOfWeek === 6) {
    counter = 2
    return counter
  }

  if (dayOfWeek === 0 || hour >= 20) counter = 1

  return counter
}

export function getDayToCall() {
  const today = new Date()

  const tomorrowNumber = today.setDate(today.getDate() + getDayOfWeek())

  const [tomorrowDate] = new Date(tomorrowNumber).toLocaleString().split(',')

  return tomorrowDate
}

export function getDayToCallTimestam(number){
  let callDate = new Date();
  callDate.setHours(number);
  callDate.setMinutes(0);
  return Date.parse(callDate)/1000;
}

export function getDayTomorrow(number){

  let nexWorkDay = 1;
  let tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + nexWorkDay);
  tomorrow.setHours(number);
  tomorrow.setMinutes(0);
  return Date.parse(tomorrow) / 1000;
}

export function nextBusinessDay(number){
  let nexWorkDay = 2;
  let dayAfterTomorrow = new Date();
  dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + nexWorkDay);
  dayAfterTomorrow.setHours(number);
  dayAfterTomorrow.setMinutes(0);
  return Date.parse(dayAfterTomorrow)/1000;
}

export function setTextDependingOnDay() {
  let text = 'tomorrow'

  if (getDayOfWeek() === 2 || getDayOfWeek() === 3) text = 'on Monday'
  if (getDayOfWeek() === 0) text = 'today'

  return text
}
export function setTextDependingOnDayDe() {
  let text = 'morgen'

  if (getDayOfWeek() === 2 || getDayOfWeek() === 3) text = 'Montags'
  if (getDayOfWeek() === 0) text = 'heute'

  return text
}
export function setTextDependingOnDayFr() {
  let text = 'matin'

  if (getDayOfWeek() === 2 || getDayOfWeek() === 3) text = 'le lundi'
  if (getDayOfWeek() === 0) text = 'aujourdhui'

  return text
}
export function setTextDependingOnDaySpa() {
  let text = 'mañana'

  if (getDayOfWeek() === 2 || getDayOfWeek() === 3) text = 'Lunes'
  if (getDayOfWeek() === 0) text = 'Hoy'

  return text
}

export function handleDisabledOption(number){
  let state = '';

  const timeNow = new Date().getHours();
  if(number <= timeNow){
    state = 'disabled';
  }

  return state;
}

export function callMeNow(){
  const dayStart = 9;
  const now = new Date();
  let dayEnd = 19;
  let state = '';

  if(now.getDay() === 6){
    dayEnd = 16;
  }

  if(now.getHours() < dayStart || now.getHours() > dayEnd){
    state = "disabled";
  }

  return state;
}

// SET_HOUR
export function SetHourOption(){
  const today = new Date();
  const hourStart = 9;
  const normalHourClose = 19;
  let hourToday;
  let hourTomorrow;

  let hourList = `
    <option selected value="">Selecciona horario</option>
  `;
  
  today.getDay() === 6 ? hourToday = 16 : hourToday = normalHourClose ;

  if(today.getDay() === 0){
    // Este normalHourClose es fijo, ya que de momento es la hora a la que se cierra la mayoria de dias.
    for(let i = hourStart; i <= normalHourClose ; i++){
      let newOption = `<option value="${getDayTomorrow(i)}">Mañana de ${i}h a ${i + 1}h</option>`
      hourList += newOption;
    }

    return hourList;
  }

  if(today.getDay() === 6 && today.getHours() > hourToday){
     // Este normalHourClose es fijo, ya que de momento es la hora a la que se cierra la mayoria de dias.
    for(let i = hourStart; i <= normalHourClose ; i++){
      let newOption = `<option value="${nextBusinessDay(i)}">Próximo día laboral de ${i}h a ${i + 1}h</option>`
      hourList += newOption;
    }

    return hourList;
  }

  // En este punto a today se le añade un dia mas que cuando esta declarada, ojo con esto que
  // puede dar a futuros errores de uso.
  const tomorrow = today.setDate(today.getDate() + 1)
  new Date(tomorrow).getDay() === 6 ? hourTomorrow = 16 : hourTomorrow = normalHourClose ;

  if(today.getHours() < hourStart){
    for(let i = hourStart; i <= hourToday ; i++){
      let newOption = `<option ${handleDisabledOption(i)} value="${getDayToCallTimestam(i)}">Hoy de ${i}h a ${i + 1}h</option>`;
      hourList += newOption;
    }
  }

  if(today.getHours() > hourToday){
    for(let i = hourStart; i <= hourTomorrow ; i++){
      let newOption = `<option value="${getDayTomorrow(i)}">Mañana de ${i}h a ${i + 1}h</option>`
      hourList += newOption;
    }
  }

  return hourList;
}